import * as React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Form, Input } from "antd";

import Swal from "sweetalert2";

import channelUserApi from "../../../apis/ChannelUser.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
// import ApiService from "../../../utils/ApiService";
import { toastAlert } from "../../AlertComponent";

// const api = new ApiService();
const SignupUserInfo = ({
	userInfo,
	setUserInfo,
	smsValid,
	setSmsValid,
	passwordValid,
}) => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [isSendSms, setIsSendSms] = useState(false);

	/**
	 * 필수 입력 항목
	 * @param e
	 */
	const handleUserInfo = (e) => {
		let { name, value } = e.target;
		let phone = value?.replaceAll(/[^0-9]/g, "");
		if (name === "phone") {
			if (phone?.length <= 11) {
				setUserInfo({
					...userInfo,
					phone: phone,
				});
			}
		} else if (name === "phone_valid") {
			if (phone?.length <= 6) {
				setUserInfo({
					...userInfo,
					[name]: phone,
				});
			}
		} else {
			setUserInfo({
				...userInfo,
				[name]: value,
			});
		}
	};

	/**
	 * step 2-1: 휴대폰 인증번호 확인
	 * @returns {Promise<void>}
	 */
	const sendPhoneValid = async () => {
		let regPhone = /010-?([0-9]{4})-?([0-9]{4})$/;
		if (regPhone.test(userInfo.phone) && reduxChannel?.nickname !== null) {
			setIsLoading(true);
			let param = {
				is_user_valid: true,
				phone: userInfo.phone,
				influencer_id: reduxChannel?.user_id,
				influencer_channel_name: reduxChannel?.nickname,
			};
			let res = await channelUserApi.sendSms(param);
			if (res.code === 200) {
				if (res.result.id_check) {
					const loginMethod =
						res.result.user?.provider === "kakao"
							? "카카오"
							: res.result.user?.provider === "naver"
							? "네이버"
							: "해당 번호";

					// if (window.confirm(`${loginMethod}로 가입된 유저가 있습니다. 로그인 하시겠습니까?`)) {
					//     history.push(`/together/channel/login?id=${reduxChannel?.influencer_id}`);
					//     setIsSendSms(true);
					// }

					Swal.fire({
						customClass: "alert-custom",
						text: `${loginMethod}로 가입된 유저가 있습니다.\n로그인 하시겠습니까?`,
						showCancelButton: true,
						confirmButtonText: "확인",
						cancelButtonText: "취소",
					}).then(async (result) => {
						if (result.isConfirmed) {
							history.push(
								`/together/channel/login?id=${reduxChannel?.influencer_id}`
							);
							setIsSendSms(true);
						}
					});
				} else {
					setIsSendSms(true);
				}
				setIsLoading(false);
			} else {
				toastAlert("휴대폰 번호를 정확하게 입력해주세요.");
				setIsLoading(false);
			}
		} else {
			toastAlert("휴대폰 번호를 정확하게 입력해주세요.");
		}
	};

	/**
	 * step 2-2: 휴대폰 인증번호 일치 확인
	 */
	const checkPhoneValid = async () => {
		const regPhone = /([0-9]{6})$/;
		if (regPhone.test(userInfo.phone_valid)) {
			setIsLoading(true);

			let param = {
				phone: userInfo.phone,
				sms_verify_code: userInfo.phone_valid,
			};
			let res = await channelUserApi.sendSmsValid(param);

			if (res.code === 200) {
				toastAlert("인증번호가 일치합니다.");
				setSmsValid(true);
				setIsLoading(false);
			} else {
				toastAlert("인증번호가 일치하지 않습니다.");
				setIsLoading(false);
			}
		} else {
			toastAlert("휴대폰 번호를 정확하게 입력해주세요.");
		}
	};

	return (
		<>
			<p className={`signup-sub-title signup-border`}>필수 입력 항목</p>

			<Form layout={`vertical`} className={`signup-userInfo-div`}>
				<Form.Item label="휴대폰 인증" labelAlign="left" colon={false}>
					<Input
						type={`text`}
						name={`phone`}
						placeholder={`휴대폰 번호를 입력해주세요`}
						value={userInfo.phone}
						pattern="\d*"
						onChange={handleUserInfo}
						onPressEnter={sendPhoneValid}
						disabled={isSendSms}
					/>
					{!isSendSms && (
						<Button
							className={`button-width-full`}
							onClick={sendPhoneValid}
							loading={isLoading}
						>
							인증 요청
						</Button>
					)}
				</Form.Item>
				{!!isSendSms && (
					<Form.Item label="휴대폰 인증번호" labelAlign="left" colon={false}>
						<Input
							type={`text`}
							name={`phone_valid`}
							placeholder={`인증번호 6자리를 입력해주세요`}
							value={userInfo.phone_valid}
							pattern="\d*"
							onChange={handleUserInfo}
							onPressEnter={checkPhoneValid}
							disabled={smsValid}
						/>
						{smsValid ? (
							<Button
								className={`button-width-full finish-gray`}
								disabled={true}
							>
								인증 완료
							</Button>
						) : (
							<Button
								className={`button-width-full`}
								onClick={checkPhoneValid}
								loading={isLoading}
								disabled={
									!userInfo.phone_valid || userInfo.phone_valid?.length < 6
								}
							>
								인증번호 확인
							</Button>
						)}
					</Form.Item>
				)}
				<Form.Item label="비밀번호" labelAlign="left" colon={false}>
					<Input
						type={`password`}
						name={`password`}
						placeholder={`8자리 이상 비밀번호를 입력해주세요.`}
						value={userInfo.password}
						onChange={handleUserInfo}
						disabled={!smsValid}
					/>
				</Form.Item>
				<Form.Item label="비밀번호 확인" labelAlign="left" colon={false}>
					<Input
						type={`password`}
						name={`password_valid`}
						placeholder={`8자리 이상 비밀번호를 입력해주세요.`}
						value={userInfo.password_valid}
						onChange={handleUserInfo}
						disabled={!smsValid}
					/>
					{!!userInfo.password_valid?.length && smsValid && (
						<>
							{!passwordValid && (
								<p className={`caution`}>*비밀번호를 확인해주세요</p>
							)}
						</>
					)}
				</Form.Item>
			</Form>
		</>
	);
};
export default SignupUserInfo;
